export const SET_POSTS = 'SET_POSTS'
export const SET_CATEGORIES = 'SET_CATEGORIES'
export const SET_CURRENTPOST = 'SET_CURRENTPOST'
export const SET_CURRENTCATEGORY = 'SET_CURRENTCATEGORY'
export const SET_ARCHIVE_SEO = 'SET_ARCHIVE_SEO'
